import React, { useState } from 'react';
import OrderListTemplate from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { useDefaultQueryFields } from '../order.effect';

const ReceiptManagementList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const reloadList = () => setRefreshKey(k => k + 1);
  const tabScene = OrderTabScene.GroupReceiptManagement;
  const queryFields = useDefaultQueryFields(tabScene);

  const targets: OrderTriggerTarget[] = ['viewReceiptEvidence'];

  const renderTableActions = (order: MergedOrder) => (
    <OrderTriggerActionMap layout="table" targets={targets} order={order} onReload={reloadList} />
  );

  return (
    <OrderTriggerActionProvider onReload={reloadList}>
      <OrderListTemplate
        refreshKey={refreshKey}
        tabScene={tabScene}
        defaultScene='tab_receipt_management_all'
        queryFields={queryFields}
        viewModes={[
          { 
            mode: 'table', 
            label: '表格页',
            showField: 'receiptManagement',
            renderActions: renderTableActions,
          },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default ReceiptManagementList;
